import usePopup from './usePopup';

const useConsumerPopup = rendering => {
  const { popupId, setPopupId } = usePopup();
  const currentComponentId = rendering?.dataSource?.replace('{', '')?.replace('}', '')?.toLowerCase();
  const isCurrentPopup = () => currentComponentId === popupId;

  return { setPopupId, isCurrentPopup };
};

export default useConsumerPopup;
